import { useScroll, useTransform } from "framer-motion";
import { MDiv } from "src/swsh-native";
import { GatheringHeaderRegularParallaxWrapperProps } from "./types";

const GatheringHeaderRegularParallaxWrapper = ({
	children,
	clippedHeight,
}: GatheringHeaderRegularParallaxWrapperProps) => {
	const { scrollY } = useScroll();
	const opacity = useTransform(scrollY, [0, clippedHeight], [1, 0]);
	const translateY = useTransform(scrollY, [0, clippedHeight], [0, 0.4 * clippedHeight]);
	const scale = useTransform(scrollY, [0, clippedHeight], [1, 0.6]);

	return <MDiv style={{ opacity, translateY, scale }}>{children}</MDiv>;
};
export default GatheringHeaderRegularParallaxWrapper;
